<div class="gb-dialog-header">
  <h1 class="gb-dialog-title" translate="PRESENTER.CONFIGURE_TEMPLATE_TITLE"></h1>

  <button mat-icon-button type="button" mat-dialog-close>
    <gb-icon icon="close"></gb-icon>
  </button>
</div>

<div class="gb-dialog-content">
  <gb-presenter-template-config [template]="selectedTemplate$ | async"></gb-presenter-template-config>
</div>

<div class="gb-dialog-actions-container gb-flex-button-container">
  @if (isSaveProjectorAsTemplateMode) {
    <button mat-flat-button type="button" [mat-dialog-close]="template" translate="SAVE"></button>
  } @else {
    <button mat-flat-button type="button" (click)="save()" translate="SAVE"></button>
  }
</div>
